import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.dev';
import { AuthStoreService } from 'src/app/core/services/auth-store.service';

@Injectable({
  providedIn: 'root'
})
export class BotService {
  private readonly API_URL = environment.apiUrl;
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private authStore: AuthStoreService
  ) {
    this.headers = new HttpHeaders();
  }

  private getOrGenerateGuestId(): string {
    let guestId = sessionStorage.getItem('gbot_guest_id');
    if (!guestId) {
      guestId = 'guest_' + Math.random().toString(36).substring(2, 9);
      sessionStorage.setItem('gbot_guest_id', guestId);
    }
    return guestId;
  }

  sendMessage(message: string): Observable<{ response: string }> {
    let userId: string | number | undefined = this.authStore.currentUser?.id;

    if (!userId) {
      try {
        const userDataStr = localStorage.getItem('userData');
        if (userDataStr) {
          const userData = JSON.parse(userDataStr);
          userId = userData.id || userData.userId;
        }
      } catch (e) {
        // Ignorar error al parsear JSON
      }
    }

    if (!userId) {
      userId = this.getOrGenerateGuestId();
    }

    const body = {
      message,
      user_id: userId
    };

    return this.http.post<any>(`${this.API_URL}/bot`, body).pipe(
      map((res: any) => {
        const text = res?.response || res?.reply || res?.message || res?.data || (typeof res === 'string' ? res : 'No se recibió respuesta válida.');
        return { response: text };
      })
    );
  }
}
